import { render } from "./SuperAdminHome.vue?vue&type=template&id=487caa07&scoped=true"
import script from "./SuperAdminHome.vue?vue&type=script&lang=js"
export * from "./SuperAdminHome.vue?vue&type=script&lang=js"

import "./SuperAdminHome.vue?vue&type=style&index=0&id=487caa07&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487caa07"]])

export default __exports__